import Vue from "vue";
import Vuex from "vuex";
import addresses from "./Modules/addresses";
import services from "./Modules/services";
import countries from "./Modules/countries";
import servicesTypes from "./Modules/services-types";
import Auth from "./Modules/login";
import documents from "./Modules/documents";
import servicioRapido from "./Modules/servicioRapido";
import globalTypes from "./types/global";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ["Auth"], //"servicioRapido"
  key: "PortalSzendex"
});

export default new Vuex.Store({
  state: {
    processing: false,
    loading: false,
    isMobile: false
  },
  getters: {
    [globalTypes.getters.processing]: state => state.processing
  },
  mutations: {
    [globalTypes.mutations.startProcessing](state) {
      state.processing = true;
    },
    [globalTypes.mutations.stopProcessing](state) {
      state.processing = false;
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
    setMobile(state, bool) {
      state.isMobile = bool;
    }
  },
  modules: {
    addresses,
    services,
    countries,
    servicesTypes,
    Auth,
    documents,
    servicioRapido
  },
  plugins: [vuexLocal.plugin]
});
